import { Elements } from '@tfo/common'
import * as React from 'react'
import { useIntl } from 'react-intl'
import { useScimStyles } from './scimShared'

const { Paragraph } = Elements

type Props = {
  errorKey: string | null
}

export const ScimConfirmDisableView: React.FC<Props> = ({ errorKey }) => {
  const intl = useIntl()
  const styles = useScimStyles()
  return (
    <>
      <Paragraph>{intl.formatMessage({ id: 'sso.scim.confirmDisable.description' })}</Paragraph>
      {errorKey && <Paragraph className={styles.errorText}>{intl.formatMessage({ id: errorKey })}</Paragraph>}
    </>
  )
}
